import { render, staticRenderFns } from "./DetailLookSync.vue?vue&type=template&id=3d48fd75&scoped=true&"
import script from "./DetailLookSync.vue?vue&type=script&lang=js&"
export * from "./DetailLookSync.vue?vue&type=script&lang=js&"
import style0 from "./DetailLookSync.vue?vue&type=style&index=0&id=3d48fd75&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48fd75",
  null
  
)

export default component.exports